import { ToothChartStage } from '@/components/dental/ToothChartStage';
import { ShortcutsPanel } from '@/components/dental/shortcuts/ShortcutsPanel';
import { useShortcutMode } from '@/components/dental/shortcuts/ShortcutModeContext';
import { SessionPanel } from '@/components/dental/session/SessionPanel';

// ── Props ─────────────────────────────────────────────────────────────────────

interface SessionRouteProps {
  patientId: string;
  clinicId: string;
}

// ── Component ─────────────────────────────────────────────────────────────────

export function SessionRoute({ patientId, clinicId }: SessionRouteProps) {
  const { activeShortcutId, toggleShortcut } = useShortcutMode();

  return (
    <div className="flex h-full overflow-hidden">
      {/* Left rail: shortcuts */}
      <ShortcutsPanel
        clinicId={clinicId}
        activeShortcutId={activeShortcutId}
        onShortcutToggle={toggleShortcut}
        className="w-[220px] shrink-0"
      />

      {/* Main column: chart + session panel */}
      <div className="flex flex-1 min-w-0 flex-col overflow-hidden">
        {/* Chart */}
        <div className="flex-none p-4 lg:p-6">
          <ToothChartStage
            patientId={patientId}
            clinicId={clinicId}
            activeShortcutId={activeShortcutId}
          />
        </div>

        {/* Session panel (scrollable) */}
        <div className="border-t border-slate-200 dark:border-slate-700 flex-1 min-h-0 overflow-hidden">
          <SessionPanel
            patientId={patientId}
            clinicId={clinicId}
            className="h-full"
          />
        </div>
      </div>
    </div>
  );
}
